/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import {
  faFileImage,
  faFileAudio,
  faFileVideo,
  faFloppyDisk
} from '@fortawesome/free-regular-svg-icons'

import {
  faMicrochip,
  faBorderNone,
  faFileCirclePlus,
  faPencil,
  faFont,
  faEye,
  faHeart,
  faCamera,
  faClapperboard,
  faToggleOn,
  faToggleOff,
  faEyeSlash,
  faXmark,
  faCheck,
  faDivide,
  faGripVertical,
  faVectorSquare,
  faPlus,
  faCirclePlus,
  faMinus,
  faSliders,
  faArrowPointer,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faSort,
  faCog,
  faMagnet,
  faSortUp,
  faSortDown,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faFile,
  faFileMedical,
  faImage,
  faVideo,
  faVolumeOff,
  faSun,
  faBrain,
  faRobot,
  faBook,
  faBookAtlas,
  faBookBookmark,
  faFilm,
  faUpDownLeftRight,
  faCompress,
  faRotate,
  faFill,
  faPlay,
  faPause,
  faForward,
  faBackward,
  faCircle,
  faCircleStop,
  faExpand,
  faCube,
  faSprayCanSparkles,
  faMountainSun,
  faVolumeLow,
  faTreeCity,
  faPerson,
  faMusic,
  faUser,
  faSpinner,
  faThumbsUp,
  faRightFromBracket,
  faMicrophone
} from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(
  faThumbsUp,
  faMicrochip,
  faBorderNone,

  faFileImage,
  faFileAudio,
  faFileVideo,
  faFloppyDisk,

  faTreeCity,
  faPerson,
  faMusic,
  faUser,
  faSpinner,
  faMicrophone,

  faFileCirclePlus,
  faFont,
  faPencil,
  faEye,
  faHeart,
  faCamera,
  faClapperboard,
  faToggleOn,
  faToggleOff,
  faEyeSlash,
  faXmark,
  faCheck,
  faDivide,
  faGripVertical,
  faVectorSquare,
  faPlus,
  faCirclePlus,
  faMinus,
  faSliders,
  faArrowPointer,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronLeft,
  faChevronRight,
  faSort,
  faCog,
  faMagnet,
  faSortUp,
  faSortDown,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faFile,
  faFileMedical,
  faImage,
  faVideo,
  faVolumeOff,
  faSun,
  faBrain,
  faRobot,
  faBook,
  faBookAtlas,
  faBookBookmark,
  faFilm,
  faUpDownLeftRight,
  faCompress,
  faRotate,
  faFill,
  faPlay,
  faPause,
  faForward,
  faBackward,
  faCircle,
  faCircleStop,
  faExpand,
  faCube,
  faSprayCanSparkles,
  faMountainSun,
  faVolumeLow,
  faRightFromBracket
)

export const FaIcon = FontAwesomeIcon
export const FaLayer = FontAwesomeLayers
